<template>
  <div class="satisfied">
    <h3>{{ _T('What do you think about us') }}?</h3>
    <div class="about-question">
      <p>
        {{ _T('Overall') }}, {{ _T('how satisfied are you with Go Order') }}?
      </p>
      <ul class="selection-type">
        <li
          v-for="item in 5"
          :key="item"
          :class="{ active: rating1 == item }"
          @click="rating1 = item"
        >
          <a href="#">
            <svg width="25" height="24" fill="none">
              <use class="active-fill" :xlink:href="'#smily' + item" />
            </svg>
          </a>
        </li>
      </ul>
    </div>
    <div class="about-question">
      <p>{{ _T('How likely are you to buy from us again') }}?</p>
      <ul class="selection-type">
        <li
          v-for="item in 5"
          :key="item"
          :class="{ active: rating2 == item }"
          @click="rating2 = item"
        >
          <a href="#">
            <svg width="25" height="24" fill="none">
              <use class="active-fill" :xlink:href="'#smily' + item" />
            </svg>
          </a>
        </li>
      </ul>
    </div>
    <div class="about-question">
      <p>{{ _T('Would you recommend Go Order to others') }}?</p>
      <ul class="selection-type">
        <li
          v-for="item in 5"
          :key="item"
          :class="{ active: rating3 == item }"
          @click="rating3 = item"
        >
          <a href="#">
            <svg width="25" height="24" fill="none">
              <use class="active-fill" :xlink:href="'#smily' + item" />
            </svg>
          </a>
        </li>
      </ul>
    </div>
    <div class="about-question">
      <p>
        {{ _T('Would you like to tell us more') }}?
        {{ ' ' + _T('Please type in below') }}:
      </p>
      <div class="form-group">
        <textarea rows="5" class="form-control"></textarea>
      </div>
    </div>
    <ul class="btns-full">
      <li>
        <button
          type="button"
          class="btn btn-outline btn-block"
          data-dismiss="modal"
          onclick="window.location.href = 'on_going_order.html';"
        >
          {{ _T('Detail Order') }}
        </button>
      </li>
      <li>
        <button
          type="button"
          class="btn btn-solid btn-block"
          data-dismiss="modal"
          @click="close"
        >
          {{ _T('Done') }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      rating1: '',
      rating2: '',
      rating3: '',
    }
  },
  computed: {
    ...mapGetters(['_T']),
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">
.satisfied {
  padding: calc(#{$px30} + (90 - 30) * ((100vw - #{$px320}) / (1920 - 320)))
    calc(#{$px20} + (33 - 20) * ((100vw - #{$px320}) / (1920 - 320)))
    calc(#{$px15} + (33 - 15) * ((100vw - #{$px320}) / (1920 - 320)));
  h3 {
    font-weight: bold;
    margin-bottom: calc(
      #{$px15} + (34 - 15) * ((100vw - #{$px320}) / (1920 - 320))
    );
  }
  .selection-type {
    li {
      use {
        &.active-fill {
          fill: $dark-border;
        }
      }
      &.active {
        use {
          &.active-fill {
            fill: rgba(var(--color-warning-color-source), 0.8);
          }
        }
      }
      + li {
        margin-left: calc(
          #{$px10} + (20 - 10) * ((100vw - #{$px320}) / (1920 - 320))
        );
      }
    }
  }
  .about-question {
    p {
      margin-bottom: calc(
        #{$px8} + (12 - 8) * ((100vw - #{$px320}) / (1920 - 320))
      );
    }
    + .about-question {
      margin-top: calc(
        #{$px16} + (32 - 16) * ((100vw - #{$px320}) / (1920 - 320))
      );
    }
    .form-group {
      margin-bottom: calc(
        #{$px30} + (58 - 30) * ((100vw - #{$px320}) / (1920 - 320))
      );
    }
  }
  .btns-full {
    display: flex;
    li {
      width: 100%;
      .btn {
        padding: calc(#{$px8} + (13 - 8) * ((100vw - #{$px320}) / (1920 - 320)))
          calc(#{$px18} + (28 - 18) * ((100vw - #{$px320}) / (1920 - 320)))
          calc(#{$px8} + (13 - 8) * ((100vw - #{$px320}) / (1920 - 320)));
      }
      .btn-outline {
        color: $font-color;
        border-color: $font-color;
        &:hover {
          background-color: $font-color;
          color: $white;
        }
      }
      + li {
        margin-left: calc(
          #{$px10} + (14 - 10) * ((100vw - #{$px320}) / (1920 - 320))
        );
      }
    }
  }
}
</style>
